import {
  IconComponentStyled,
  UploaderInputStyled,
  UploaderStyled,
} from '@procurify/ui'
import { em, rem } from 'polished'
import styled from 'styled-components'

export const ImporterUploaderContentStyled = styled.div`
  font-size: ${rem(16)};

  position: relative;

  text-align: center;

  border: 1px solid ${(props) => props.theme.colors.content.border};
  padding: ${em(16)};

  display: flex;
  justify-content: center;
  align-items: center;

  > ${IconComponentStyled} {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%) translateY(-80%);

    z-index: 2;

    background: ${(props) => props.theme.colors.white};
  }

  ${UploaderStyled} {
    border: none;

    ${UploaderInputStyled} {
      display: block;
      background: none;
      padding: 0;
    }
  }
`
